import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import TemplatePage from '../../../pageTemplates/DropDownPages';
import TemplateData from '../../../../content/whatWeDoPages/solutions/webrtcInfrastructureAsCode';


const WebrtcInfrastructureAsCode = () => {
  return <TemplatePage pageData={TemplateData} />
};

export default WebrtcInfrastructureAsCode;